module.exports = ".content{\r\n    overflow: auto;\r\n    height: 400px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-dashboard/optimizer/week-search-result-dialog/week-search-result-dialog.component.css
// module id = ./src/app/admin-dashboard/optimizer/week-search-result-dialog/week-search-result-dialog.component.css
// module chunks = main